import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { useAnimateLottie } from '../../hooks'

export interface OrbLottieProps {
  size?: number
  loop?: boolean
  loadingPulseOrb?: boolean
}

const OrbContainer = styled.View<{ size: number; offset: number }>(({ size, offset }) => ({
  margin: `-${offset}px`,
  width: `${size}px`,
  height: `${size}px`,
}))

export const OrbLottie: FunctionComponent<OrbLottieProps> = ({ size = 284, loop = true, loadingPulseOrb = false }) => {
  const { AnimationView } = useAnimateLottie()
  const adjustedSize = size * 1.23 // Size adjusted to account for the blur effect that overflows the view box
  const offset = adjustedSize * 0.1

  return (
    <OrbContainer size={adjustedSize} offset={offset}>
      <AnimationView
        source={
          loadingPulseOrb
            ? require('../../assets/lottie/loading-pulse-orb.json')
            : require('../../assets/lottie/load-in-orb.json')
        }
        loop={loop}
        autoPlay={true}
        style={{ height: adjustedSize, width: adjustedSize }}
      />
    </OrbContainer>
  )
}
